const STORAGE_KEY = 'idenfo_session_overrides'
import Vue from 'vue'
export default {
    namespaced: true,
    
    state: {
        onboardingConfigurations: {}, // Default values from dataSegmentConfigurations
        fieldConfigurations: [], // { [key]: { isRequired: boolean } } - explicit overrides only
        documentFieldConfigurations: [], // { [id]: { label: string, defaultRequired: boolean } } - document upload items from API
    },

    getters: {
        onboardingConfigurations: (state) => state.onboardingConfigurations,
        fieldConfigurations: (state) => state.fieldConfigurations,
        documentFieldConfigurations: (state) => state.documentFieldConfigurations,
    },

    mutations: {
       
        /**
         * Set field required override (only if different from default)
         * @param {Object} payload - { key: string, isRequired: boolean }
         */
        // SET_FIELD_CONFIGURATION(state, { key, isRequired, status }) {
        //     if (!state.fieldConfigurations) state.fieldConfigurations = {};
          
        //     const current = state.fieldConfigurations[key] || {};
          
        //     // Update required
        //     if (typeof isRequired !== 'undefined') {
        //       current.isRequired = !!isRequired;
        //     }
          
        //     // Update activation
        // if (typeof status !== 'undefined') {
        //       current.status = status === 'inactive' ? 'inactive' : 'active';
        //     }
          
        //     // If you have a defaults map and want to remove overrides when equal,
        //     // compare here and delete when identical; otherwise, keep it simple:
        //     state.fieldConfigurations[key] = current;
        //   },
          

        /**
         * Bulk set field required overrides
         * @param {Array} pairs - [{key: string, isRequired: boolean}, ...]
         */
        BULK_SET_FIELD_REQUIRED(state, pairs) {
            pairs.forEach(({ key, isRequired }) => {
                if (!state.fields[key]) {
                    state.fields[key] = {}
                }
                state.fields[key].isRequired = isRequired
            })
        },

        /**
         * Reset all field overrides
         */
        RESET_FIELDS(state) {
            state.fields = {}
        },

        /**
         * Hydrate state from localStorage
         */
        HYDRATE_FROM_STORAGE(state, payload) {
            if (payload.step) {
                state.step = { ...state.step, ...payload.step }
            }
            if (payload.stepDefaults) {
                state.stepDefaults = { ...payload.stepDefaults }
            }
            if (payload.fields) {
                state.fields = { ...payload.fields }
            }
            if (payload.availableFieldKeys) {
                state.availableFieldKeys = [...payload.availableFieldKeys]
            }
            if (payload.fieldDefaults) {
                state.fieldDefaults = { ...payload.fieldDefaults }
            }
            if (payload.fieldLabels) {
                state.fieldLabels = { ...payload.fieldLabels }
            }
        },

        /**
         * Remove a field override
         * @param {string} key - field key
         */
        REMOVE_FIELD_OVERRIDE(state, key) {
            if (state.fields[key]) {
                delete state.fields[key]
            }
        },
/**
         * Set a step override
         * @param {Object} payload - { key: string, value: boolean|null }
         */
SET_ONBOARDING_CONFIGURATIONS(state, configurations) {
    state.onboardingConfigurations = { ...configurations }
},
        /**
         * Set field defaults map (from API)
         * @param {Object} defaults - { key: originalIsRequired, ... }
         */
        // SET_FIELD_CONFIGURATIONS(state, configurations) {
        //     state.fieldConfigurations = [ ...configurations ]
        // },
        SET_FIELD_CONFIGURATIONS(state, payload) {
            if (Array.isArray(payload)) {
              // handle array input
              state.fieldConfigurations = [ ...payload ]
            } else if (payload && typeof payload === 'object') {
              // handle single object input
              const idx = state.fieldConfigurations.findIndex(f => f.key === payload.key)
              if (idx !== -1) {
                state.fieldConfigurations[idx] = {
                  ...state.fieldConfigurations[idx],
                  ...payload
                }
              } else {
                state.fieldConfigurations.push(payload)
              }
            }
          },
           // preferred single entry point
  UPSERT_OVERRIDE(state, payload) {
    if (!state.fieldConfigurations) Vue.set(state, 'fieldConfigurations', [])
    const list = state.fieldConfigurations
    const idx = list.findIndex(f => f.key === payload.key)
    console.log("idx",idx)
    console.log("list",list)
    console.log("payload",payload)
    const next = idx !== -1 ? { ...list[idx], ...payload } : payload
    if (idx !== -1) {
      Vue.set(list, idx, next)
    } else {
      list.push(next)
    }
  },
        /**
         * Set document upload items from API
         * @param {Object} items - { [id]: { label: string, defaultRequired: boolean } }
         */
        SET_DOCUMENT_FIELD_CONFIGURATIONS(state, configurations) {
            if (Array.isArray(configurations)) {
                state.documentFieldConfigurations = [ ...configurations ]
            } else if (configurations && typeof configurations === 'object') {
                const idx = state.documentFieldConfigurations.findIndex(f => f.key === configurations.key)
                if (idx !== -1) {
                    state.documentFieldConfigurations[idx] = {
                        ...state.documentFieldConfigurations[idx],
                        ...configurations
                    }
                } else {
                    state.documentFieldConfigurations.push(configurations)
                }
            }
        },
    },

    actions: {
        /**
         * Hydrate state from localStorage
         */
        hydrate({ commit }) {
            try {
                const stored = localStorage.getItem(STORAGE_KEY)
                if (stored) {
                    const payload = JSON.parse(stored)
                    commit('HYDRATE_FROM_STORAGE', payload)
                }
            } catch (error) {
                console.error('Error hydrating session overrides:', error)
            }
        },

        /**
         * Persist current state to localStorage
         */
        persist({ state }) {
            try {
                const payload = {
                    step: state.step,
                    stepDefaults: state.stepDefaults,
                    fields: state.fields,
                    availableFieldKeys: state.availableFieldKeys,
                    fieldDefaults: state.fieldDefaults,
                    fieldLabels: state.fieldLabels,
                }
                localStorage.setItem(STORAGE_KEY, JSON.stringify(payload))
            } catch (error) {
                console.error('Error persisting session overrides:', error)
            }
        },

        /**
         * Clear all overrides and localStorage
         */
        clear({ commit }) {
            commit('RESET_STEPS')
            commit('RESET_FIELDS')
            try {
                localStorage.removeItem(STORAGE_KEY)
            } catch (error) {
                console.error('Error clearing session overrides:', error)
            }
        },
    },
}

